export default {
  validationError: {
    allowedMinTooLarge: 'min > max',
    allowedMaxTooSmall: 'max < min',
    defaultValueExceedAllowed: 'Default value violated allowed interval.',
  },
};
